import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs";
import { ServerFilterParams } from "../common/common.model";
import { ServereListesideBaseClass } from "../common/listeside/servere.listeside.component";
import { ServereService } from "../server/server.service";
import { TilgangService } from "../services/tilgang.service";


@Component({
  selector: "app-servere",
  templateUrl: "./servere.component.html"
})
export class ServereComponent extends ServereListesideBaseClass {

  overskrift = "Oversikt over Servere";

  constructor(
    private service: ServereService,
    tilgangService: TilgangService, route: ActivatedRoute, router: Router
  ) { super(route, router, tilgangService); }


  search(params: ServerFilterParams): Observable<any> {
    return this.service.search(params.tekst, params.order, params.pageNumber, params.pageSize, params.hasSystem);
  }

}
